import PropTypes from "prop-types"
import { cardDataShape } from "../shapes"

/**
 * PropTypes for Dashboard view
 *
 * @property {Array<CardData>} [cardsData] - Array of metric card data
 * @property {Array<Object>} [alerts] - Array of alert/notification data
 * @property {Array<TableHeader>} [alertHeaders] - Alert table headers
 * @property {Object} [lifetimeSales] - Lifetime sales chart data
 * @property {Object} [lifetimeKwh] - Lifetime kWh chart data
 * @property {Object} [lifetimeCredit] - Lifetime credit-consumption chart data, CEME-only
 */
export const dashboardPropTypes = {
	cardsData: PropTypes.arrayOf(cardDataShape),
	alerts: PropTypes.arrayOf(PropTypes.object),
	alertHeaders: PropTypes.array,
	lifetimeSales: PropTypes.object,
	lifetimeKwh: PropTypes.object,
	lifetimeCredit: PropTypes.object,
}

/**
 * PropTypes for MetricsCards component
 *
 * @property {Array<CardData>} cardsData - Array of card data objects (required)
 */
export const metricsCardsPropTypes = {
	cardsData: PropTypes.arrayOf(cardDataShape).isRequired,
}

/**
 * PropTypes for ChartsSection component
 *
 * @property {Object} lifetimeSales - Sales chart data
 * @property {Object} lifetimeKwh - kWh chart data
 * @property {Object} [lifetimeCredit] - Credit-consumption chart data, omitted when CEME-only capability is absent
 * @property {string} salesFilter - Current sales filter value
 * @property {string} kwhFilter - Current kWh filter value
 * @property {string} [creditFilter] - Current credit chart filter value
 * @property {Array<FilterOption>} secondaryFilterOptions - Secondary filter options
 * @property {function} onTimeRangeChange - Time range change handler
 * @property {function} onSecondaryFilterChange - Secondary filter change handler
 */
export const chartsSectionPropTypes = {
	lifetimeSales: PropTypes.object.isRequired,
	lifetimeKwh: PropTypes.object.isRequired,
	lifetimeCredit: PropTypes.object,
	salesFilter: PropTypes.string.isRequired,
	kwhFilter: PropTypes.string.isRequired,
	creditFilter: PropTypes.string,
	secondaryFilterOptions: PropTypes.array.isRequired,
	onTimeRangeChange: PropTypes.func.isRequired,
	onSecondaryFilterChange: PropTypes.func.isRequired,
}

/**
 * PropTypes for AlertsTable component
 *
 * @property {Array<Object>} alerts - Array of alert data
 * @property {Array<TableHeader>} alertHeaders - Table column headers
 */
export const alertsTablePropTypes = {
	alerts: PropTypes.arrayOf(PropTypes.object).isRequired,
	alertHeaders: PropTypes.array.isRequired,
}

/**
 * PropTypes for AlertsOverview component
 *
 * @property {Array<Object>} alerts - Array of alert records
 */
export const alertsOverviewPropTypes = {
	alerts: PropTypes.arrayOf(PropTypes.object).isRequired,
}

/**
 * PropTypes for PriorityAlertsSection wrapper
 *
 * @property {Array<Object>} alerts - Alert rows
 * @property {Array<TableHeader>} alertHeaders - Table headers
 */
export const priorityAlertsSectionPropTypes = {
	alerts: PropTypes.arrayOf(PropTypes.object).isRequired,
	alertHeaders: PropTypes.array.isRequired,
}
